import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, defer, Observable, Subscription, throwError, timer } from 'rxjs';
import { catchError, filter, finalize, map, shareReplay, switchMap, take } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
// import { CampaignRequest } from '../../models/Campaign/CampaignRequest.model';
import { BaseResponse } from '../../models/BaseResponse.model';
import { flowScreenEnum } from '../../models/flow/flowScreenEnum';
import { ScreenData } from '../../models/flow/ScreenData.model';
import { ProcessStepRequest } from '../../models/flow/ProcessStepRequest.model';
import { LoaderService } from '../loader/loader.service';
import { StorageService } from '../Storage/storage.service';
import { UtilityService } from '../utility/utility.service';
import { ProcessStepResponse } from '../../models/flow/ProcessStepResponse.model';
import { EntryEnum } from '../../models/flow/entry-enum';
import { LoggerApiService } from '../logger/logger-api.service';
import { NetworkStatusService } from '../../shared/services/network-status/network-status.service';
import { GetScreenDataResponse } from 'src/app/models/flow/GetScreenDataResponse.model';
import { RequestRetryService } from '../request-retry/request-retry.service';
declare function callOutJsProgress(value: any): any;

@Injectable({
  providedIn: 'root'
})
export class FlowService {
  isThankAndEnd: EventEmitter<boolean> = new EventEmitter();
  hideOrder: EventEmitter<boolean> = new EventEmitter();
  flowNotFromS8 = true;
  scrollbarvalue: number = 3;
  // public ifAllowBackScreen = false;
  // public ArrayScreenflow:{screenId : string, barValue: number}[]=[];
  ArrayScreenflow: string[] = [];

  private screenChange$: BehaviorSubject<flowScreenEnum | null> = new BehaviorSubject<flowScreenEnum | null>(null);
  
  get screenChange(): Observable<flowScreenEnum> {
    return this.screenChange$
      .asObservable()
      .pipe(filter(s => s !== null));
  }

  private baseUrlController = 'Flow';
  constructor(
    private http: HttpClient,
    private router: Router,
    private loaderService: LoaderService,
    public storageService: StorageService,
    private utility: UtilityService,
    private loggerApi: LoggerApiService,
    private networkStatus: NetworkStatusService,
    private requestRetryService: RequestRetryService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      // takeUntil(this.destroy$)
    ).subscribe((r) => {
      const screen = this.getFlowScreenEnumByUrl(this.router.url);
      if (screen) {
        this.screenChange$.next(screen as flowScreenEnum);
      }
    });
  }

  // public ProcessStep(req: ProcessStepRequest): Observable<ProcessStepResponse> {
  //   return this.http.post<ProcessStepResponse>(`${environment.baseApiUrl}/${this.baseUrlController}/ProcessStep`, req).pipe(
  //     map(res => {

  //       let _res = res;

  //       if (res.IsSuccessful) {
  //        // this.appStateService.updateState(new OnInitCustomerSuccess(state));
  //       } else {
  //        // this.appStateService.updateState(new OnInitCustomerFailed(state));
  //       }
  //       return res;
  //     })

  // , catchError(err => {
  //   //this.sendHttpLog('UpdateContractorWorkTask', `${this.baseApiUrl}/${this.BaseApiController}/UpdateContractorWorkTask`, {}, 'Response', err);
  //   //return throwError(err);
  //     // let _res : ProcessStepResponse;
  //     // _res.IsSuccessful = false;

  //     let _res: ProcessStepResponse = {
  //          IsSuccessful : false

  //      };
  //    // _res.ErrorMessage = err;

  //   return _res;
  // })
  //    );
  // }

  ProcessStep(req: ProcessStepRequest, flowReqNum: number = 0): Observable<ProcessStepResponse> {
    // Log request sent
    this.loggerApi.sendEventLog({
      event: 'flow_request_sent',
      request: req,
      url: window.location.href,
      entry: this.storageService.getEntry(),
      token: this.storageService.getToken()
    });
    req = this.utility.removeNullAndUndefinedPropertiesFromObject(req);
    if (req.Data) {
      req.Data = this.utility.removeNullAndUndefinedPropertiesFromJson(req.Data);
    }
    const header = new HttpHeaders({
      timeout: '600000'
    });


    return this.http
      .post<ProcessStepResponse>(
        `${environment.baseApiUrl}/${this.baseUrlController}/ProcessStep`,
        req,
        {
          headers: header
        }
      )
      .pipe(
        map(res => {
          // Log response received
          this.loggerApi.sendEventLog({
            event: 'flow_response_received',
            timestamp: new Date(),
            url: window.location.href,
            request: req,
            response: res,
            entry: this.storageService.getEntry(),
            token: this.storageService.getToken()
          });
          if (res.IsSuccessful && res.NextScreen != null) {
            if (res.NextScreen != 'S14') {
              this.ArrayScreenflow = JSON.parse(sessionStorage.getItem('Array_Screen') || '[]')
                ? JSON.parse(sessionStorage.getItem('Array_Screen') || '[]')
                : [];

              if (!this.ArrayScreenflow.find(obj => obj == res.NextScreen)) {
                let entry = this.storageService.getEntry();
                if (entry === EntryEnum.IspBzkPass || entry === EntryEnum.WifiKids || entry === EntryEnum.WsFilter) {
                  // entry=='Vas'||
                  this.scrollbarvalue = this.scrollbarvalue + 25;
                } else {
                  if (entry === EntryEnum.Vas) {
                    this.scrollbarvalue = this.scrollbarvalue + 20;
                  } else {
                    this.scrollbarvalue = this.scrollbarvalue + 12;
                  }
                }

                this.ArrayScreenflow.push(res.NextScreen);

                // let obj = this.ArrayScreenflow.find(obj => obj.screenId == res.NextScreen);
                // obj.screenId = res.NextScreen;
                // obj.barValue = this.scrollbarvalue;
                // this.ArrayScreenflow.push(obj);

                sessionStorage.setItem('Array_Screen', JSON.stringify(this.ArrayScreenflow));
                this.storageService.setSessionValue('lastscrollbar_value', this.scrollbarvalue);

                //let progressDiv =  this.roundProgressBarElement._elementRef.nativeElement.querySelector('div.mat-progress-bar-primary');
                //var progressDiv = document.getElementsByClassName('.mat-progress-bar-primary');
                //document.querySelectorAll('.class1.class2');

                //var progressDiv = angular.element(element.getElementsByClassName("multi-files"));
                callOutJsProgress(this.scrollbarvalue);
                //progressDiv[0].style = this.scrollbarvalue + '%';

                this.storageService.setSessionValue('nextScreen', res.NextScreen);
              }

              // else if(this.ArrayScreenflow.find(obj => obj.screenId == res.NextScreen))
              // {
              //   this.ArrayScreenflow = JSON.parse(sessionStorage.getItem('Array_Screen')) ? JSON.parse(sessionStorage.getItem('Array_Screen')) : [];
              //   this.scrollbarvalue = this.ArrayScreenflow.find(obj => obj.screenId == res.NextScreen).barValue;
              // }
            } else {
              this.scrollbarvalue = 100;
              this.storageService.setSessionValue('lastscrollbar_value', this.scrollbarvalue);
              this.storageService.setSessionValue('nextScreen', res.NextScreen);
              callOutJsProgress(this.scrollbarvalue);
            }
          } else if (!res.IsSuccessful) {
            // Log error
            this.loggerApi.sendEventLog({
              event: 'flow_response_error',
              timestamp: new Date(),
              url: window.location.href,
              request: req,
              response: res,
              entry: this.storageService.getEntry(),
              token: this.storageService.getToken()
            });
          }
          return res;
        }),
        catchError(error => {
          // if we are online and have retries left, we retry
          // if we are offline, we wait until we are back online to retry, even if out of retries
          // if we are online and out of retries, we handle the error
          if (flowReqNum < 3 && this.networkStatus.isOnline) {
            this.loggerApi.sendEventLog({
              event: 'flow_request_retry' ,
              timestamp: new Date(),
              url: window.location.href,
              request: req,
              error: error,
              entry: this.storageService.getEntry(),
              token: this.storageService.getToken()
            });
            // Retry the original ProcessStep method with a delay of 100 milliseconds using RxJS timer
            return timer(100).pipe(
              switchMap(() => this.ProcessStep(req, flowReqNum + 1))
            );
          } else if (!this.networkStatus.isOnline) {
            // even if flowReqNum is greater than max retries, we wait until back online to retry once again
            return this.networkStatus.onlineStatus$.pipe(
              filter(isOnline => isOnline), // Only proceed when online
              take(1), // Unsubscribe after the first emission
              switchMap(() => {
                // Retry the original ProcessStep method with a delay of 100 milliseconds using RxJS timer
                return timer(100).pipe(
                  switchMap(() => {
                    this.loggerApi.sendEventLog({
                      event: 'flow_request_retry',
                      timestamp: new Date(),
                      url: window.location.href,
                      request: req,
                      error: error,
                      entry: this.storageService.getEntry(),
                      token: this.storageService.getToken()
                    });
                    return this.ProcessStep(req, flowReqNum + 1);
                  })
                );
              })
            );
          } else {
            return this.handleError(error, req);
          }
        }),
        shareReplay(1)
      );
  }

  getFirstScreenByEntry(entry: string): flowScreenEnum {
      let firstScreen: flowScreenEnum = flowScreenEnum.S20;

      switch (entry) {
        case EntryEnum.NewPack:
        case EntryEnum.NewBan:
        case EntryEnum.Cpo:
          firstScreen = flowScreenEnum.S20; break;
        case EntryEnum.Elct:
          firstScreen = flowScreenEnum.S101; break;
        case EntryEnum.Relocation:
          firstScreen = flowScreenEnum.S28; break;
        default:
          firstScreen = flowScreenEnum.S29; break;
      }

      return firstScreen;
  }

  // ProcessStepold(req: ProcessStepRequest): Observable<any> {
  //   req = this.utility.removeNullAndUndefinedPropertiesFromObject(req);
  //   if (req.Data) {
  //     req.Data = this.utility.removeNullAndUndefinedPropertiesFromJson(req.Data);
  //   }

  //   return this.http.post<any>(`${environment.baseApiUrl}/${this.baseUrlController}/ProcessStep`, req).pipe(
  //     map(res => {
  //       return res;
  //     }),
  //     catchError(error => this.handleError(error))

  //     // catchError(err => {
  //     //   console.log(err);
  //     //   return throwError(err);
  //     // })

  //     //,share()
  //   );
  // }

  // ProcessStep10(req: ProcessStepRequest) {
  //   const header = new HttpHeaders({
  //     timeout: '600000',
  //   });
  //   let res ;
  //   this.http.post(`${environment.baseApiUrl}/${this.baseUrlController}/ProcessStep`,
  //     req,)
  //      .timeout(300000, new Error('timeout exceeded'))
  //      .map(res => res.json())
  //      .subscribe(
  //        data => res = data,
  //        error => console.debug('ERROR', error),
  //        () => {console.log('END')
  //       return res;}
  //      );
  // }

  GetScreenData(req: ScreenData) {
    // this.scrollbarvalue = this.storageService.getSessionValue('lastscrollbar_value')?this.storageService.getSessionValue('lastscrollbar_value'):3;
    // callOutJsProgress(this.scrollbarvalue);
    // Keep the B loader active for every retry attempt and release it on final completion.
    return defer(() => {
      const completeLoading = this.storageService.isElectricityEntry() ? null : this.loaderService.beginLoading();

      // Retry raw server failures before callers interpret screen data or popup state.
      return this.requestRetryService.execute(() => this.http.post<GetScreenDataResponse>(
        `${environment.baseApiUrl}/${this.baseUrlController}/GetScreenData`,
        req
      )).pipe(
        map(res => res),
        finalize(() => completeLoading?.())
      );
    });
  }

  isCurrentScreenEntryScreen(): boolean {
    const currentScreen = this.getRouterName(window.location.href)?.toLowerCase();
    const currentScreenIsEntryScreen = currentScreen &&
      (currentScreen === 's20' || currentScreen === 's1' || currentScreen === 's28' || currentScreen === 's29' || currentScreen === 's101');
    return !!currentScreenIsEntryScreen;
  }

  getFlowScreenEnumByUrl(url: string): flowScreenEnum | null {
    const routerName = this.getRouterName(url);
    return routerName ? flowScreenEnum[routerName.toUpperCase() as keyof typeof flowScreenEnum] : null;
  }
  
  getRouterName(url: string): string {
    let path = url.split('/');
    let routerName = path[path.length - 1].split('?');
    routerName = routerName[0].split(';');
    // S29 has different route than in flow screen enum, need to fix it
    // TODO: try to fix it right, using same route as in the flow screen enum
    routerName[0] = routerName[0].toLowerCase() === 'identitynumber' ? 'Identification' : routerName[0];
    return Object.entries(flowScreenEnum).find(([key, val]) => 
      val.toLowerCase() === routerName[0].toLowerCase()
    )?.[0] || '';
  }

  private handleError(error: Response | any, request: ProcessStepRequest): Observable<any> {
    this.loaderService.changeLoaderState(false);
    // tslint:disable-next-line:prefer-const
    console.log(error);
    const res: BaseResponse = {
      IsSuccessful: false,
      ErrorCode: '-1',
      ErrorMessage: 'אירעה שגיאה, אנא נסה שנית במועד מאוחר יותר'
    };

    // Log error
    this.loggerApi.sendEventLog({
      event: 'flow_response_error_catch',
      timestamp: new Date(),
      url: window.location.href,
      request: request,
      error: error,
      entry: this.storageService.getEntry(),
      token: this.storageService.getToken()
    });

    //  return new Observable.create(observe => {
    return new Observable(observe => {
      observe.next(res);
      observe.complete();
    });
  }
}
